import React, { useState,useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const EditComType = ({ show, onClose, complainttypeIdToEdit,refresh }) => {
    const [complainttype_name, setname] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [existingComplainttype, setExistingComplainttype] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    // const [colorChange] = useState(null);

    const formatcomplainttypeName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    useEffect(() => {
        if (show && complainttypeIdToEdit) {
            axios.get(`${baseURL}/complainttype/${complainttypeIdToEdit}`)
                .then(response => {
                    console.log("Fetched complainttype:", response.data);
                    console.log("Fetched complainttype:", response.data);
                    const complainttype = response.data.data;
                    setname(complainttype.complainttype_name);
                    setDescription(complainttype.description || '');
                })
                .catch(error => {
                    console.error("Error fetching complainttype", error);
                });

                axios.get(`${baseURL}/complainttype`)
                .then(response => {
                    setExistingComplainttype(
                        response.data.data
                            .filter(c => c.sno !== complainttypeIdToEdit) // exclude current one
                            .map(complainttype => complainttype.complainttype_name.toLowerCase())
                    );
                })
                .catch(error => {
                    console.error("Error fetching countries", error);
                });
        }
    }, [show, complainttypeIdToEdit]);

    const validateInput = () => {
        // Check if the Complaint type name is empty
        if (!complainttype_name.trim()) {
            setError("Complainttype is required.");
            return false;
        }
        
        const regex = /^[A-Za-z\s]+$/;
        if (!regex.test(complainttype_name)) {
            setError("Only text is valid.");
            return false;
        }
        
        const formattedcomplainttypeName = complainttype_name.trim().toLowerCase();
        // Check if the complainttype already exists
        if (existingComplainttype.includes(complainttype_name.trim().toLowerCase())) {
            setError("Complainttype already exists.");
            return false;
        }

        setError('');
        return true;
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        const formattedcomplainttypeName = formatcomplainttypeName(complainttype_name);

        if (!validateInput()) return;

        axios.put(`${baseURL}/complainttype/${complainttypeIdToEdit}`, {
            complainttype_name,
            description
        })
            .then(response => {
                refresh();
                onClose();
                // window.location.reload(); // optional, can use state update instead
                toast.success("Complaint type Updated successfully!");
            })
            .catch(error => {
                console.error("Error updating Complaint type", error);
                setError("An error occurred while updating the Complaint type.");
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Complaint Type</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleUpdate}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Complaint Type<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Complaint Type"  value={complainttype_name}
                            onChange={(e) => setname(formatcomplainttypeName(e.target.value))}/>
                            {error && <small className="text-danger">{error}</small>}
                        </div>
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Background Color<span className="required">*</span></label>
                            <input type="color" className="form-control" value={'#abebc6'} placeholder="Enter Complaint Type" />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Text Color<span className="required">*</span></label>
                            <input type="color" className="form-control" value={'#fbfcfc'} placeholder="Enter Complaint Type" />
                        </div> */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={4} className="form-control h-auto" name="comment" placeholder="Description" value={description}
                            onChange={(e) => setDescription(e.target.value)}/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button type="submit" className="btn btn-sm btn-primary">Update Complaint Type<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditComType;
